import { useConfigContext } from "@/state/configContext";

type SelectProductoProps = {
  temporada: number;
  value: number;
  onSelect: (id: number) => unknown;
};

export function SelectProducto({
  value,
  onSelect,
  temporada,
}: SelectProductoProps) {
  const config = useConfigContext();

  return (
    <select
      className="producto"
      onChange={(event) => onSelect(Number(event.target.value))}
      value={value}
    >
      {config.temporadas[temporada].productos.map((p) => (
        <option value={p.id} key={p.id}>
          {p.descripcion}
        </option>
      ))}
    </select>
  );
}
